<template>
    <CustomDialog
        v-model="show"
        hideHeader
        hideCloseIcon
        persistent
    >
        <div class="max-mob:px-4 px-7.5 pb-7.5 pt-10 max-mob:py-5 min-w-120 max-mob:min-w-full text-center">
            <TwoFactorAuthIcon class="mx-auto mb-4"/>

            <div class="mb-2 text-gray-370 dark:text-white text-lg font-medium uppercase">
                Enable Two-Factor Authentication
            </div>

            <div class="text-gray-200 text-xs">
                To keep your account secure, please enable

                <div class="max-mob:inline">
                    two-factor authentication within <span class="text-gray-370 dark:text-white">{{ days }} days</span>.
                </div>

                <div class="max-mob:inline">
                    After that, access to the platform will be restricted.
                </div>

            </div>
        </div>

        <template #footer>
            <div class="flex items-center justify-end w-full gap-x-5">
                <TextBtn
                    text="text-gray-280 dark:text-gray-100 hover:text-purple dark:hover:text-purple"
                    :loading="twoFactorAuthentication.actionLoading"
                    @click="onRemindLater"
                >
                    Remind me later
                </TextBtn>

                <PrimaryBtn
                    class="w-32.5"
                    @click="onEnableTwoFA"
                >
                    Enable 2FA
                </PrimaryBtn>
            </div>
        </template>
    </CustomDialog>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRouter } from 'vue-router'

import CustomDialog from '@/components/dialogs/CustomDialog.vue'
import PrimaryBtn from '@/components/buttons/PrimaryBtn.vue'
import TwoFactorAuthIcon from '@/components/icons/TwoFactorAuthIcon.vue'
import TextBtn from '@/components/buttons/TextBtn.vue'

import { ROUTES } from '@/constants/routes'

import { useAuthorizationStore } from '@/store/authorizationStore'
import { useTwoFactorAuthentication } from '@/store/call-tracking/twoFactorAuthentication'

const authorizationStore = useAuthorizationStore()
const twoFactorAuthentication = useTwoFactorAuthentication()

const router = useRouter()

const show = ref(false)

const days = computed(() => {
    const two_factor_enforcement = authorizationStore.two_factor_enforcement
    return two_factor_enforcement.days_left
})

async function onRemindLater() {
    const { success } = await twoFactorAuthentication.goToRemindLater()

    if (success) {
        onCloseDialog()
    }
}

function onEnableTwoFA() {
    onCloseDialog()
    router.push({ name: ROUTES.twoFactorAuth })
}

function onCloseDialog() {
    show.value = false
}

onMounted(() => {
    show.value = authorizationStore.isGracePeriodUserTwoFactor
})
</script>
